import { EventEmitter, input, SimpleChanges, } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { DEFAULT_SECURITY_GROUP_TAB_OPTIONS, DEFAULT_SECURITY_LIST_MODAL_HEADER_TEXT, SET_OPERATION_RADIO_BUTTONS, SET_OPERATION_TO_RADIO_BUTTON_MAP, } from '../constants';
import { COMPANY, SECURITYLIST_GROUP_MULTI } from 'Angular/constants/core.constants';
import { INTERSECT } from 'SecurityListsApp/ts/constants';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SecurityListMenuService } from 'SecurityListsApp/ts/services/security-list-menu.service';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import { findPathForSecuritylistItem } from 'SecurityListsApp/ts/utils/security-list-utils';
import * as i0 from "@angular/core";
import * as i1 from "SecurityListsApp/ts/services/security-list-menu.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i5 from "../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
import * as i6 from "../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i7 from "../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i8 from "../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i9 from "../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i10 from "../../../../../../../../ycharts/static/ts/features/components/inputs/radio-button-group/radio-button-group.component";
import * as i11 from "../components/autocompleter-single-select-list/autocompleter-single-select-list.component";
import * as i12 from "../components/category-list/category-list.component";
import * as i13 from "../components/security-list-group-tabs/security-list-group-tabs.component";
import * as i14 from "SecurityListsApp/ts/features/security-list-selector-modals/components/multi-level-single-select-list/multi-level-single-select-list.component";
const _c0 = ["categoryList"];
const _c1 = ["singleSelectList"];
const _c2 = a0 => ({ "tab-pane active": a0 });
const _c3 = a0 => ({ "linked-lists-no-border": a0 });
function SecurityListSelectorModalComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.modalSubtitle);
} }
function SecurityListSelectorModalComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.modalDescription);
} }
function SecurityListSelectorModalComponent_ycn_radio_button_group_7_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-radio-button-group", 12);
    i0.ɵɵlistener("selectHandler", function SecurityListSelectorModalComponent_ycn_radio_button_group_7_Template_ycn_radio_button_group_selectHandler_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.selectSetOperation($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("groupName", "securityListSelectorModalSetOperations")("options", ctx_r0.setOperations)("selectedObject", ctx_r0.selectedSetOperationObj);
} }
function SecurityListSelectorModalComponent_ycn_loading_symbol_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 13);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
function SecurityListSelectorModalComponent_span_10_ycn_security_list_group_tabs_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-security-list-group-tabs", 24);
    i0.ɵɵlistener("securityGroupChangeHandler", function SecurityListSelectorModalComponent_span_10_ycn_security_list_group_tabs_1_Template_ycn_security_list_group_tabs_securityGroupChangeHandler_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.selectSecurityGroup($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("activeSecurityGroupTab", ctx_r0.activeSecurityGroupTab)("securityGroupTabOptions", ctx_r0.securityGroupTabOptions);
} }
function SecurityListSelectorModalComponent_span_10_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25)(1, "ycn-icon-search-autocomplete", 26);
    i0.ɵɵlistener("submitHandler", function SecurityListSelectorModalComponent_span_10_div_13_Template_ycn_icon_search_autocomplete_submitHandler_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.selectSubListItemByAutocomplete($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("appendToBody", false)("placeholder", ctx_r0.autocompleterPlaceholder)("searchType", ctx_r0.autocompleterName);
} }
function SecurityListSelectorModalComponent_span_10_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "div", 28)(2, "ycn-multi-level-single-select-list", 29, 1);
    i0.ɵɵlistener("selectItemHandler", function SecurityListSelectorModalComponent_span_10_div_14_Template_ycn_multi_level_single_select_list_selectItemHandler_2_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.selectItem($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("listItems", ctx_r0.listItems)("selectedItem", ctx_r0.selectedSecurityList)("selectedItemSecurityGroup", ctx_r0.selectedSecurityListSecurityGroup)("activeSecurityGroupTab", ctx_r0.activeSecurityGroupTab);
} }
function SecurityListSelectorModalComponent_span_10_ycn_autocompleter_single_select_list_15_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-autocompleter-single-select-list", 30);
    i0.ɵɵlistener("selectItemHandler", function SecurityListSelectorModalComponent_span_10_ycn_autocompleter_single_select_list_15_Template_ycn_autocompleter_single_select_list_selectItemHandler_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.selectItem($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("autocompleterName", ctx_r0.autocompleterName)("autocompleterPlaceholder", ctx_r0.autocompleterPlaceholder)("selectedItem", ctx_r0.selectedSecurityList);
} }
function SecurityListSelectorModalComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, SecurityListSelectorModalComponent_span_10_ycn_security_list_group_tabs_1_Template, 1, 2, "ycn-security-list-group-tabs", 14);
    i0.ɵɵelementStart(2, "div", 15)(3, "div", 16)(4, "div", 17)(5, "div", 18)(6, "div", 19);
    i0.ɵɵtext(7, "Category");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "ycn-category-list", 20, 0);
    i0.ɵɵlistener("categoryChangeHandler", function SecurityListSelectorModalComponent_span_10_Template_ycn_category_list_categoryChangeHandler_8_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.selectCategory($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 18)(11, "div", 19);
    i0.ɵɵtext(12, "Lists");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, SecurityListSelectorModalComponent_span_10_div_13_Template, 2, 3, "div", 21)(14, SecurityListSelectorModalComponent_span_10_div_14_Template, 4, 4, "div", 22)(15, SecurityListSelectorModalComponent_span_10_ycn_autocompleter_single_select_list_15_Template, 1, 3, "ycn-autocompleter-single-select-list", 23);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isTabbed);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c2, ctx_r0.isTabbed));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c3, ctx_r0.isTabbed));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("categories", ctx_r0.categories)("selectedCategory", ctx_r0.selectedCategory);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r0.listItems.length && ctx_r0.autocompleterName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.listItems.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.listItems.length && ctx_r0.autocompleterName);
} }
/**
 * Security List Selector Modal Component
 *
 * Displays a menu where you can select a security list from a variety of groups and categories.
 *
 * Input Properties:
 *  activeSecurityGroupTab: The security group for which the security lists are currently being displayed.
 *  clearAfterSubmit: Whether to clear out the currentSecurityList after submit. If true then the previously
 *                    submitted security list will not be selected when the modal is opened again.
 *  headerText: text to display in the modal header.
 *  hiddenCategories: categories to leave out of the menu, by name, per security group.
 *  modalSubtitle: Modal's sub title, appears bold.
 *  modalDescription: Description of the modal.
 *  securityGroupTabOptions: tabs to show in the modal.
 *  showSetOperations: Whether to show the set operation radio buttons.
 *  selectedSetOperation: the currently select set operation.
 *  submittedSecurityList: The security list that was most recently submitted from the modal.
 *  submittedSecurityListSecurityGroup: The security group that the submittedSecurityList belongs to
 *
 * Output Properties:
 *  closeModalHandler: Emits when the modal is closed.
 *  submitHandler: Emits the selected security list, security group that the selected list belongs to,
 *                 and selected set operation when the Submit button is clicked.
 */
export class SecurityListSelectorModalComponent {
    constructor(securityListMenuService, featureService) {
        this.securityListMenuService = securityListMenuService;
        this.featureService = featureService;
        this.activeSecurityGroupTab = COMPANY;
        this.clearAfterSubmit = false;
        this.headerText = DEFAULT_SECURITY_LIST_MODAL_HEADER_TEXT;
        this.hiddenCategories = input({}, ...(ngDevMode ? [{ debugName: "hiddenCategories" }] : []));
        this.securityGroupTabOptions = DEFAULT_SECURITY_GROUP_TAB_OPTIONS;
        this.showSetOperations = true;
        this.selectedSetOperation = INTERSECT;
        this.submittedSecurityList = null;
        this.errorMessage = '';
        this.submittedSecurityListSecurityGroup = null;
        this.closeModalHandler = new EventEmitter();
        this.submitHandler = new EventEmitter();
        this.autocompleterPlaceholder = '';
        // selected security list properties
        // This property holds the security list that is currently selected, but it may not have been submitted yet
        this.selectedSecurityList = null;
        // The security list group that the currently select security list belongs to
        this.selectedSecurityListSecurityGroup = null;
        // Set operations
        this.selectedSetOperationObj = SET_OPERATION_TO_RADIO_BUTTON_MAP[this.selectedSetOperation];
        this.setOperations = SET_OPERATION_RADIO_BUTTONS;
        // Menu data
        this.listItems = [];
        this.securityListMenu = null;
        // Categories
        this.categories = [];
        this.selectedCategory = '';
        // Boolean state
        this.isTabbed = this.securityGroupTabOptions.length > 1;
        this.loading = false;
        this.modalOpen = false;
        // Error Message to display
        this.errorText = '';
        // Tab that is selected when the modal is reset
        this.initialSecurityGroupTab = COMPANY;
    }
    ngOnInit() {
        this.initialSecurityGroupTab = this.activeSecurityGroupTab;
        // Fetch security list menu
        this.loading = true;
        this.securityListMenuService
            .getMenu()
            .pipe(finalize(() => {
            this.loading = false;
        }))
            .subscribe({
            next: (response) => {
                this.securityListMenu = response;
                this.selectSecurityGroup(this.activeSecurityGroupTab);
            },
            error: () => {
                this.errorText = 'There was an unexpected error. Please reload the page.';
            },
        });
    }
    ngOnChanges(changes) {
        // If securityGroupTabOptions changes then update isTabbed based on how many tabs there are
        if (changes?.securityGroupTabOptions?.currentValue) {
            this.isTabbed = this.securityGroupTabOptions.length > 1;
        }
        if (changes?.activeSecurityGroupTab?.currentValue) {
            this.initialSecurityGroupTab = this.activeSecurityGroupTab;
            this.selectSecurityGroup(this.activeSecurityGroupTab);
        }
        else if (changes?.hiddenCategories && !changes.hiddenCategories.firstChange) {
            this.selectSecurityGroup(this.activeSecurityGroupTab);
        }
    }
    openModal() {
        this.modalOpen = true;
        this.selectedSetOperationObj = {
            ...SET_OPERATION_TO_RADIO_BUTTON_MAP[this.selectedSetOperation],
        };
        // If a security list was previously submitted, then we need to select
        // the tab and category that the security list belongs to when we open the modal.
        // We also need to scroll to the previously submitted security list.
        if (this.submittedSecurityList && this.submittedSecurityListSecurityGroup && this.securityListMenu) {
            // If a security list was submitted previously then automatically select it
            this.selectedSecurityList = this.submittedSecurityList;
            this.selectedSecurityListSecurityGroup = this.submittedSecurityListSecurityGroup;
            this.selectSecurityGroup(this.selectedSecurityListSecurityGroup);
            const currentGroupCategories = this.visibleCategories(this.selectedSecurityListSecurityGroup);
            const securityListPathObj = this.selectedSecurityList.key
                ? findPathForSecuritylistItem(this.selectedSecurityList.key, currentGroupCategories)
                : null;
            if (securityListPathObj) {
                this.selectCategory(securityListPathObj.categoryName);
            }
            if (this.categoryList) {
                this.categoryList.scrollToSelected();
            }
            if (this.singleSelectList) {
                this.singleSelectList.scrollToSelected();
            }
        }
    }
    closeModal() {
        this.modalOpen = false;
        this.closeModalHandler.emit();
        this.resetModal();
    }
    resetModal() {
        this.selectedSecurityList = null;
        this.selectedSecurityListSecurityGroup = null;
        this.selectedSetOperation = INTERSECT;
        // Changing the object reference to trigger ngOnChanges in the RadioButtonGroupComponent
        this.selectedSetOperationObj = { ...SET_OPERATION_TO_RADIO_BUTTON_MAP[this.selectedSetOperation] };
        this.selectSecurityGroup(this.initialSecurityGroupTab);
        // Close all open lists
        if (this.singleSelectList) {
            this.singleSelectList.openListItems = [];
        }
    }
    submit() {
        if (this.selectedSecurityList && this.selectedSecurityListSecurityGroup) {
            /* submittedSecurityList is different from selectedSecurityList because it references
            the security list that was most recently submitted from the modal, while selectedSecurityList
            references the security list that is selected at the current moment.
            A user could open the modal and select many different security lists only to click the 'Cancel' button
            and not submit anything. In that case, submittedSecurityList will not change.
            2 distinct properties are necessary so that when the modal is opened, we can automatically scroll
            to the submittedSecurityList even if the selectedSecurityList was changed but not submitted. */
            // Update submittedSecurityList to be the currently selected security list
            this.submittedSecurityList = this.selectedSecurityList;
            this.submittedSecurityListSecurityGroup = this.selectedSecurityListSecurityGroup;
            this.submitHandler.emit({
                securityList: {
                    ...this.submittedSecurityList,
                    category: this.selectedCategory,
                },
                securityGroup: this.submittedSecurityListSecurityGroup,
                setOperation: this.selectedSetOperation,
            });
            if (this.clearAfterSubmit) {
                this.submittedSecurityList = null;
                this.submittedSecurityListSecurityGroup = null;
            }
            this.closeModal();
        }
    }
    selectItem(item, deselectIfSelected = true) {
        if (!this.featureService.userCanAccess(item)) {
            const missing_feature = this.featureService.getFirstMissingFeature(item);
            this.featureNeededModal.openModal(missing_feature);
        }
        else if (this.selectedSecurityList?.key === item.key && deselectIfSelected) {
            // If the keys match then the user must have clicked on the security list that
            // was already selected, so we should deselect it unless otherwise specified by the caller
            // in the deselectIfSelected parameter.
            this.selectedSecurityList = null;
            this.selectedSecurityListSecurityGroup = null;
        }
        else {
            this.selectedSecurityList = item;
            this.selectedSecurityListSecurityGroup = this.activeSecurityGroupTab;
        }
    }
    selectCategory(newCategoryName) {
        this.selectedCategory = newCategoryName;
        const categorySubMenu = this.visibleCategories(this.activeSecurityGroupTab).find((categoryMenu) => categoryMenu.name === newCategoryName);
        if (categorySubMenu) {
            this.listItems = categorySubMenu.list_items || [];
            this.autocompleterName = categorySubMenu.autocompleter_name;
            this.autocompleterPlaceholder = `Search for ${categorySubMenu.name}`;
        }
    }
    selectSetOperation(newSetOperation) {
        this.selectedSetOperation = newSetOperation;
    }
    selectSecurityGroup(newSecurityGroup) {
        this.activeSecurityGroupTab = newSecurityGroup;
        this.categories = this.visibleCategories(newSecurityGroup).map((category) => category.name);
        this.listItems = [];
        if (this.categories.length) {
            this.selectCategory(this.categories[0]);
        }
        else {
            this.selectedCategory = '';
            this.autocompleterName = undefined;
        }
    }
    /**
     * The categories a group offers, which is every category it has minus the ones the caller hides.
     */
    visibleCategories(securityGroup) {
        const hidden = this.hiddenCategories()[securityGroup] ?? [];
        return (this.securityListMenu?.[securityGroup] ?? []).filter((category) => !hidden.includes(category.name));
    }
    selectSubListItemByAutocomplete(autocompleteResult) {
        // find the sub list item with the id in the key that matches
        // the id of the autocomplete result that was selected
        for (let i = 0; i < this.listItems.length; i += 1) {
            const sublist = this.listItems[i].sub_list;
            if (sublist) {
                const subItemFound = sublist.find((subItem) => {
                    const typeAndId = subItem.key.split('-');
                    const subItemId = parseInt(typeAndId[typeAndId.length - 1], 10);
                    return subItemId === autocompleteResult.id;
                });
                if (subItemFound) {
                    this.selectItem(subItemFound, false);
                    return;
                }
            }
        }
    }
    getMyWatchlistsCategory() {
        if (!this.securityListMenu) {
            return null;
        }
        const myListsTab = this.securityListMenu[SECURITYLIST_GROUP_MULTI];
        const watchlistsSecurityListCategory = myListsTab.find((category) => {
            return category.name === 'Watchlists';
        });
        if (watchlistsSecurityListCategory) {
            return watchlistsSecurityListCategory.list_items.find((subList) => subList.name === 'My Watchlists');
        }
        return null;
    }
    /**
     * Adds a new watchlist to the appropriate section of the security list menu.
     * @param newWatchlist: Watchlist object
     */
    addWatchlistToMenu(newWatchlist) {
        const myWatchlists = this.getMyWatchlistsCategory();
        if (myWatchlists && myWatchlists.sub_list) {
            myWatchlists.sub_list.push(newWatchlist);
            myWatchlists.sub_list.sort((a, b) => {
                const nameA = a.name.toLowerCase();
                const nameB = b.name.toLowerCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });
        }
    }
    /**
     * Removes a watchlist from the "My Watchlists" section of the security list menu.
     * @param keyToRemove
     */
    removeWatchlistFromMenu(keyToRemove) {
        const myWatchlists = this.getMyWatchlistsCategory();
        if (myWatchlists && myWatchlists.sub_list) {
            myWatchlists.sub_list = myWatchlists.sub_list.filter((item) => item.key !== keyToRemove);
        }
    }
}
SecurityListSelectorModalComponent.ɵfac = function SecurityListSelectorModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SecurityListSelectorModalComponent)(i0.ɵɵdirectiveInject(i1.SecurityListMenuService), i0.ɵɵdirectiveInject(i2.FeatureService)); };
SecurityListSelectorModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SecurityListSelectorModalComponent, selectors: [["ycn-security-list-selector-modal"]], viewQuery: function SecurityListSelectorModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.categoryList = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.singleSelectList = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededModal = _t.first);
    } }, inputs: { activeSecurityGroupTab: "activeSecurityGroupTab", clearAfterSubmit: "clearAfterSubmit", headerText: "headerText", hiddenCategories: [1, "hiddenCategories"], modalSubtitle: "modalSubtitle", modalDescription: "modalDescription", securityGroupTabOptions: "securityGroupTabOptions", showSetOperations: "showSetOperations", selectedSetOperation: "selectedSetOperation", submittedSecurityList: "submittedSecurityList", errorMessage: "errorMessage", submittedSecurityListSecurityGroup: "submittedSecurityListSecurityGroup" }, outputs: { closeModalHandler: "closeModalHandler", submitHandler: "submitHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 13, vars: 10, consts: [["categoryList", ""], ["singleSelectList", ""], [3, "closeModalHandler", "open"], [3, "closeModalHandler", "resetModalHandler", "header", "resetModalText"], [1, "modal-body"], [1, "modal-section", "form-row"], [1, "custom-control-description"], [4, "ngIf"], [3, "groupName", "options", "selectedObject", "selectHandler", 4, "ngIf"], [1, "modal-section"], [3, "loaderMessage", 4, "ngIf"], ["data-test-id", "security-list-selector-modal-footer", 3, "cancelHandler", "submitHandler", "disableSubmission", "errorText"], [3, "selectHandler", "groupName", "options", "selectedObject"], [3, "loaderMessage"], ["class", "tabs tabs-bordered", 3, "activeSecurityGroupTab", "securityGroupTabOptions", "securityGroupChangeHandler", 4, "ngIf"], [1, "tab-content", "linked-list"], [3, "ngClass"], [1, "linked-lists", 3, "ngClass"], [1, "linked-list"], [1, "linked-list-header", "user-select-none"], [1, "linked-list-body", 3, "categoryChangeHandler", "categories", "selectedCategory"], ["class", "linked-list-body-content", 4, "ngIf"], ["class", "linked-list-body user-select-none", 4, "ngIf"], ["class", "linked-list-body", 3, "autocompleterName", "autocompleterPlaceholder", "selectedItem", "selectItemHandler", 4, "ngIf"], [1, "tabs", "tabs-bordered", 3, "securityGroupChangeHandler", "activeSecurityGroupTab", "securityGroupTabOptions"], [1, "linked-list-body-content"], [3, "submitHandler", "appendToBody", "placeholder", "searchType"], [1, "linked-list-body", "user-select-none"], [1, "linked-list-sublist", "file-table"], [1, "tbody", 3, "selectItemHandler", "listItems", "selectedItem", "selectedItemSecurityGroup", "activeSecurityGroupTab"], [1, "linked-list-body", 3, "selectItemHandler", "autocompleterName", "autocompleterPlaceholder", "selectedItem"]], template: function SecurityListSelectorModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 2);
        i0.ɵɵlistener("closeModalHandler", function SecurityListSelectorModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 3);
        i0.ɵɵlistener("closeModalHandler", function SecurityListSelectorModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); })("resetModalHandler", function SecurityListSelectorModalComponent_Template_ycn_simple_modal_header_resetModalHandler_1_listener() { return ctx.resetModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 4)(3, "div", 5)(4, "span", 6);
        i0.ɵɵtemplate(5, SecurityListSelectorModalComponent_div_5_Template, 3, 1, "div", 7)(6, SecurityListSelectorModalComponent_div_6_Template, 2, 1, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, SecurityListSelectorModalComponent_ycn_radio_button_group_7_Template, 1, 3, "ycn-radio-button-group", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 9);
        i0.ɵɵtemplate(9, SecurityListSelectorModalComponent_ycn_loading_symbol_9_Template, 1, 1, "ycn-loading-symbol", 10)(10, SecurityListSelectorModalComponent_span_10_Template, 16, 12, "span", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(11, "ycn-simple-modal-footer", 11);
        i0.ɵɵlistener("cancelHandler", function SecurityListSelectorModalComponent_Template_ycn_simple_modal_footer_cancelHandler_11_listener() { return ctx.closeModal(); })("submitHandler", function SecurityListSelectorModalComponent_Template_ycn_simple_modal_footer_submitHandler_11_listener() { return ctx.submit(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(12, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.headerText)("resetModalText", "Reset");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.modalSubtitle);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.modalDescription);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showSetOperations);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("disableSubmission", !ctx.selectedSecurityList)("errorText", ctx.errorMessage || ctx.errorText);
    } }, dependencies: [i3.NgClass, i3.NgIf, i4.FeatureNeededComponent, i5.IconSearchAutocompleteComponent, i6.LoadingSymbolComponent, i7.ModalBaseComponent, i8.SimpleModalFooterComponent, i9.SimpleModalHeaderComponent, i10.RadioButtonGroupComponent, i11.AutocompleterSingleSelectListComponent, i12.CategoryListComponent, i13.SecurityListGroupTabsComponent, i14.MultiLevelSingleSelectListComponent], encapsulation: 2 });
